import { RootState } from "@/app/stores"
import { approveJobApplication, rejectJobApplication } from "@/shared/api/employment"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchApproveApplication = createAsyncThunk<
    void,
    void,
    { state: RootState}
>(`updateJobApplication/fetchApproveApplication`, async(_, thunkAPI) => {
    try {
        const { currentApplication } = thunkAPI.getState().updateJobApplication
        const data = await approveJobApplication(currentApplication.id)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
export const fetchRejectApplication = createAsyncThunk<
    void,
    string,
    { state: RootState}
>(`updateJobApplication/fetchRejectApplication`, async(comment, thunkAPI) => {
    try {
        const { currentApplication } = thunkAPI.getState().updateJobApplication
        const data = await rejectJobApplication(currentApplication.id, comment)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})